import { render, staticRenderFns } from "./Policemedicalfilter.vue?vue&type=template&id=2736a6c2&"
import script from "./Policemedicalfilter.vue?vue&type=script&lang=js&"
export * from "./Policemedicalfilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports